export default "__VITE_ASSET__9493ee56__"